import {offlineActionCreators} from 'react-native-offline';

import {createPromisedAction} from '/util/action.util';

export const PUSH_TO_OFFLINE_QUEUE: string = 'NETWORK/PUSH_TO_OFFLINE_QUEUE';

export const pushToOfflineQueue = createPromisedAction(
  PUSH_TO_OFFLINE_QUEUE,
  ['promisedAction', 'params'],
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  (dispatchMe: any, {promisedAction, params}: any, dispatch: any) => {
    return Promise.resolve()
      .then(() =>
        dispatch(
          offlineActionCreators.fetchOfflineMode(promisedAction(params)),
        ),
      )
      .then(dispatchMe(() => ({})));
  },
);
